import React from 'react';
import Numpad from '../../../img/numpad.svg'
import '../styles/config-numpad.scss';

interface Props {
    src?: string;
    id?: string;
    preloader?: JSX.Element;
    className?: string;
    cacheGetRequests?: boolean;
    onLoad?: (src: string, isCached: boolean) => any;
    onError?: () => any;
}

export const NumpadIcon: React.FunctionComponent<Props> = () => {
    return (
        <div className={'numpad-icon__wrapper'}>
            <img src={Numpad} className={'numpad-icon'} alt={'Numpad Icon'} />
        </div>
    );
};

